const state = () => ({
  vehicleSearchConfig: {} // facets object keyed by facet name
});

export default {
  namespaced: true,

  state,

  getters: {
    getVehicleSearchConfig: (state) => state.vehicleSearchConfig,

    // optional helper getter (often useful in UI)
    hasVehicleSearchConfig: (state) => Object.keys(state.vehicleSearchConfig).length > 0
  },

  mutations: {
    setVehicleSearchConfig(state, vehicleSearchConfig) {
      state.vehicleSearchConfig =
        vehicleSearchConfig && typeof vehicleSearchConfig === 'object' && !Array.isArray(vehicleSearchConfig) ? vehicleSearchConfig : {};
    },

    clearVehicleSearchConfig(state) {
      state.vehicleSearchConfig = {};
    }
  },

  actions: {
    updateVehicleSearchConfig({ commit }, vehicleSearchConfig) {
      commit('setVehicleSearchConfig', vehicleSearchConfig);
    },

    clearVehicleSearchConfig({ commit }) {
      commit('clearVehicleSearchConfig');
    }
  }
};
